import { Box, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

/**
 * LightBoxToolbar — filename + rotation degrees left, action buttons right.
 * @param {object} props
 * @param {string} props.fileName
 * @param {number} props.rotation - current rotation in degrees
 * @param {Function} props.onRotateCCW
 * @param {Function} props.onRotateCW
 * @param {Function} props.onDownload
 * @param {Function} props.onDelete
 * @param {Function} props.onClose
 */
export default function LightBoxToolbar({ fileName, rotation, onRotateCCW, onRotateCW, onDownload, onDelete, onClose }) {
    return (
        <Box id="lightbox-toolbar" className="lightbox-toolbar">

            {/* Left — filename + rotation indicator */}
            <Box className="lightbox-toolbar-info">
                <span className="lightbox-toolbar-filename">{fileName}</span>
                <span className="lightbox-toolbar-rotation">— {rotation}°</span>
            </Box>

            {/* Right — action buttons */}
            <Box className="lightbox-toolbar-actions">
                <Tooltip title="Rotate left"><IconButton onClick={onRotateCCW} className="lightbox-btn"><RotateLeftIcon /></IconButton></Tooltip>
                <Tooltip title="Rotate right"><IconButton onClick={onRotateCW} className="lightbox-btn"><RotateRightIcon /></IconButton></Tooltip>
                <Tooltip title="Download"><IconButton onClick={onDownload} className="lightbox-btn"><DownloadIcon /></IconButton></Tooltip>
                <Tooltip title="Delete"><IconButton onClick={onDelete} className="lightbox-btn lightbox-btn-delete"><DeleteOutlineIcon /></IconButton></Tooltip>
                <Tooltip title="Close"><IconButton onClick={onClose} className="lightbox-btn"><CloseIcon /></IconButton></Tooltip>
            </Box>

        </Box>
    );
}
